// ─── Mock User ────────────────────────────────────────────────────────────────
// All onboarding docs pre-signed so Training & Goals are accessible during testing.
// In production this comes from /api/me.
export const MOCK_USER = {
  id: "usr_001",
  full_name: "Alex Rivera",
  email: "alex.rivera@propertunity.com",
  phone: "+1 (305) 555-0142",
  title: "Sales Representative",
  role: "sales_rep",
  registered_at: "2024-11-01T00:00:00Z",
  onboarding: {
    contract_signed: true,
    nda_signed: true,
    tax_form_signed: true,
  },
};

// ─── Mock Goals ───────────────────────────────────────────────────────────────
export const MOCK_GOALS = {
  monthly_calls:   40,
  monthly_loans:   3,
  monthly_revenue: 25000,
  ytd_calls:       187,
  ytd_loans:       11,
  ytd_revenue:     94500,
  current_month_calls:   18,
  current_month_loans:   1,
  current_month_revenue: 8200,
};